









import { Component, Mixins } from "vue-property-decorator";
import { DeveloperPresentableMixin, DeveloperQuittableMixin } from "../../mixins";

@Component({
  components: {
  }
})
export default class DeveloperModeEditor extends Mixins(DeveloperPresentableMixin, DeveloperQuittableMixin) {
  data(): any {
    return {
      source: false,
    };
  }
  source: boolean;

  mounted(): void {
    this.source = this.isDeveloperMode;
  }

  apply(): void {
    if (this.source) {
      this.isDeveloperMode = true;
    } else {
      this.quitDeveloperMode();
    }
  }
}
